module.exports = __webpack_public_path__ + "media/images/hero_images/about-800-ac1e8225f685c2233cf0d0b456919037.jpg";